import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import config from "../../config.json";
import axios from "axios";
import { Box, Grid, Typography } from "@mui/material";
import { FeaturesTab } from "../common/features-tab/features-tab";
import { GameVideo } from "../common/game-video/game-video";
import { SpecialFeaturesCard } from "../common/special-features-card/special-features-card";
import { GameCard } from "../common/game-card/game-card";

const Home = () => {
    const [serverStats, setServerStats] = useState({
        serverOnline: false,
        onlinePlayers: 0
    });

    const fetchOnlineStatus = async () => {
        try {
            const { data } = await axios.get(config.apiEndPoint + 'statistics');
            setServerStats({
                serverOnline: !!data?.serverOnline,
                onlinePlayers: data?.onlinePlayers ?? 0
            });
        } catch (ex) {
            console.log('failed=', ex);
        }
    };

    useEffect(() => {
        fetchOnlineStatus();
    }, []);

    return (
        <Box>
            {/* Features and Video Section */}
            <Box className="bg-white py-3">
                <Container>
                    <div className="grid grid-cols-3 gap-5">
                        <div className="col-span-1">
                            <FeaturesTab />
                        </div>
                        <div className="col-span-2">
                            <GameVideo />
                        </div>
                    </div>
                </Container>
            </Box>

            {/* Server Status Section */}
            <Box sx={{ minHeight: "400px" }} className="bg-black">
                <Container>
                    <Box sx={{ pt: 6 }}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <GameCard
                                title="Server Status"
                                value={serverStats?.serverOnline ? "ONLINE" : "OFFLINE"}
                                icon="fa-desktop"
                            />
                            <GameCard
                                title="Online Players"
                                value={serverStats?.onlinePlayers ?? 0}
                                icon="fa-users"
                            />
                        </div>
                    </Box>
                </Container>
            </Box>

            {/* Special Features Section */}
            <Box sx={{ minHeight: "400px" }} className="text-brand-gray-100 bg-white">
                <Container>
                    <Box className="text-center pt-24">
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            Our Special Features
                        </Typography>
                        <Typography>
                            I won't lie, if you are looking for an easy server you should look elsewhere.
                        </Typography>
                        <Typography>
                            This is purely for people looking to regain that old, classic; "nostalgia" feeling.
                        </Typography>
                        <Typography>
                            This is a server for people with skill, where a little hard work goes a long long way.
                        </Typography>
                    </Box>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
                        <SpecialFeaturesCard title="Closest Experience" value="Best Conquer Online experience as much as you used to experience it." icon="fa-certificate" />
                        <SpecialFeaturesCard title="Fairest Ever" value="FREE of battle power, Siding for a particular player and donation items." icon="fa-lightbulb-o" />
                        <SpecialFeaturesCard title="Simply & Clean" value="The pure client 1.0 interface with high graphics engine." icon="fa-podcast" />
                        <SpecialFeaturesCard title="Best Rate" value="Real low rates & experience as it was on Conquer Online 1.0." icon="fa-star" />
                        <SpecialFeaturesCard title="Advance Emulator" value="Custom Conquer online emulator to make special classic game-play." icon="fa-cog" />
                        <SpecialFeaturesCard title="BattlEye" value="Extremely anti cheat and self report to provide fair game." icon="fa-eye" />
                    </div>
                </Container>
            </Box>

            {/* Social Widgets Section */}
            <Box className="bg-gray-100 py-10">
                <Container>
                    <Grid container spacing={4} justifyContent="center">
                        {/* Discord */}
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6" gutterBottom>Join Us on Discord</Typography>
                            <Box sx={{ height: 400, borderRadius: 1, overflow: 'hidden' }}>
                                <iframe
                                    src="https://discord.com/widget?id=1377323957862010921&theme=dark"
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allowTransparency="true"
                                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                                    title="Discord Widget"
                                ></iframe>
                            </Box>
                        </Grid>

                        {/* Facebook */}
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6" gutterBottom>Follow Us on Facebook</Typography>
                            <Box sx={{ height: 400, borderRadius: 1, overflow: 'hidden' }}>
                                <iframe
                                    src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/GeneConquer&tabs=timeline&width=400&height=400"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none' }}
                                    scrolling="no"
                                    frameBorder="0"
                                    allowFullScreen={true}
                                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                    title="Facebook Widget"
                                ></iframe>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default Home;
